import { Box, Button, Card, Container, Stack } from '@mui/material';
import HeaderBreadcrumbs from 'src/components/header-bread-crumbs/HeaderBreadcrumbs';
import Page from 'src/components/page/page';
import useLPCouponsList from './coupons-lp-list.hook';
import BenefitApprovalTabs from 'src/components/benefit-approval-tabs/benefit-approval-tabs';
import DataGridCustom from 'src/components/data-grid-custom';
import LpProductTableFilter from '../products-lp-list/components/lp-product-table-filter/lp-product-table-filter';
import { paths } from 'src/routes/paths';

export default function LPCouponsList() {
  const {
    tabValue,
    benefits,
    sortModel,
    paginationModel,
    search,
    headers,
    isLoading,
    initialVisibleColumns,
    roles,
    setPaginationModel,
    setSortModel,
    navigate,
    onChangeTab,
    setSearch,
    setAppliedFilters,
  } = useLPCouponsList();

  return (
    <Page title='Homologação de Cupons'>
      <Container maxWidth='xl'>
        <HeaderBreadcrumbs
          heading='Homologação de Cupons'
          links={[]}
        />
        <Stack direction='row' justifyContent='space-between' alignItems='center'>
          <BenefitApprovalTabs onChangeTab={onChangeTab} value={tabValue} />
          {
            roles?.some((role) =>
              ['lp_shopkeeper', 'lp_exhibitor', 'lp_contractor'].includes(role)
            ) &&
            <Button variant='contained' onClick={() => navigate(paths.dashboard.lpCouponCreate)}>
              Cadastrar Cupom
            </Button>
          }
        </Stack>
        <Box height={24} />
        <Card sx={{ p: 2 }}>
          <DataGridCustom
            columns={headers}
            rows={benefits?.data ? benefits?.data?.map((b: any) => ({ ...b, id: b._id })) : []}
            customFilters={
              <LpProductTableFilter
                searchText={search}
                setAppliedFilters={setAppliedFilters}
                setSearchText={setSearch}
              />
            }
            filteredRowsCount={benefits?.total || 0}
            totalRowsCount={benefits?.total || 0}
            initialVisibleColumns={initialVisibleColumns}
            onRowClick={({ row }) => navigate(paths.dashboard.lpCouponDetails(row.id))}
            sortModel={sortModel}
            setSortModel={setSortModel}
            paginationModel={paginationModel}
            setPaginationModel={setPaginationModel}
            isLoading={isLoading.value}
            height={400}
          />
        </Card>
      </Container>
    </Page>
  );
}
